module.exports = __webpack_public_path__ + "img/top-explanation03.cb64ed8b.png";